import { Reducer } from 'redux';

import { balanceState, balanceTypes } from './types';

const INITIAL_STATE: balanceState = {
  balanceList: [],
  totalCount: 0,
  error: false,
  loading: false,
  balanceType: [],
};

const reducer: Reducer<balanceState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES GET WALLET HISTORY
    case balanceTypes.GET_BALANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        balanceList: INITIAL_STATE.balanceList,
      };

    case balanceTypes.GET_BALANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        balanceList: action.payload.balanceList,
      };

    case balanceTypes.GET_BALANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        balanceList: INITIAL_STATE.balanceList,
      };

    // CASES WALLET DEBIT
    case balanceTypes.WALLET_DEBIT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case balanceTypes.WALLET_DEBIT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case balanceTypes.WALLET_DEBIT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case balanceTypes.CHANGE_BALANCE_TYPE:
      return {
        ...state,
        loading: false,
        error: false,
        balanceType: action.payload.balanceType,
      };

    default:
      return state;
  }
};

export default reducer;
